<template>
    <div class="album albumvideo">
        <div>
            <div class="upload-avatar">
                <div class="avatar-item" :style="{width: width + 'px',height: width + 'px'}" v-for="(imageItem, imageIndex) in data" :key="imageIndex">
                    <img :width="width" :src="imageItem"/>
                    <span class="upload-list__item-actions">
            <el-popover
                    placement="right"
                    trigger="click">
                 <img height="600" :src="imageItem"/>
              <span class="upload-list__item-preview" slot="reference">
            <el-icon class="el-icon-video-play"></el-icon>
            </span>
</el-popover>

            <span class="upload-list__item-delete" @click.stop="reMainVip(imageIndex)">
              <el-icon class="el-icon-delete"></el-icon>
            </span>
          </span>
                </div>
            </div>
            <div class="pic_img">
                <div class="pic_img_box" style="display: flex;">
                    <el-upload
                            v-if="data.length < max"
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :data="uploadData"
                            :on-progress="uploadVideoProcess"
                            :on-success="function(response, file,flList){
                            skuImg(response,file,flList)
                  }"
                            :before-upload="beforeUploadVideo"
                            :show-file-list="false"
                            :file-list="data"
                            :multiple="max > 1"
                    >
                        <i class="el-icon-plus"></i>
                        <el-progress
                                v-if="videoFlag == true"
                                type="circle"
                                v-bind:percentage="videoUploadPercent"
                                style="margin-top:7px;"
                        ></el-progress>
                        <div v-if="showTips" slot="tip" class="el-upload__tip">
                            <span>图片要求</span>
                            <span v-for="(vv, ii) in text" :key="ii">{{ ii + 1 }}.{{ vv }}</span>
                            <span>{{ text.length + 1 }}.最多上传 {{ data.length }}/{{ max }}</span>
                        </div>
                    </el-upload>
                </div>
            </div>
        </div>
        <div :style="{maxWidth:width + 'px'}">
          <select-file v-if="showSelFile" :value="data" :size="max" :file-type="2" @change="fileChanged"></select-file>
        </div>
    </div>
</template>
<script>
import { getToken } from '@/api/demo/classification/index'
import Image from '@/pages/demo/configuration/templateDialog/image'
import selectFile from '@/components/file/selectFile.vue'

export default {
  components: { selectFile, Image },
  name: 'uploadImage',
  model: {
    prop: 'filterManage',
    event: 'change'
  },
  props: {
    showSelFile: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 100
    },
    showTips: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 1
    },
    filterManage: {
      type: Array | String,
      default: () => []
    },
    text: {
      type: Array,
      default: () => ['图片大小100MB以内', '图片格式png/jpg']
    },
    buttonSize: {
      type: String,
      default: 'mini'
    }
  },
  data () {
    return {
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      https: null,
      resHttps: [],
      videoFlag: false,
      // 是否显示进度条
      videoUploadPercent: '',
      // 进度条的进度，
      isShowUploadVideo: false
    }
  },
  created () {
    this.getTokened()
  },
  computed: {
    data: {
      get () {
        if (this.max === 1) {
          return this.filterManage != null && this.filterManage.length > 0 ? [this.filterManage] : []
        }
        return this.filterManage
      },
      set () {
        if (this.max === 1) {
          return this.filterManage
        } else {
          if (this.data === '') {
            this.data = []
          }
          this.$emit(
            'change',
            this.data.map(item => {
              return item
            })
          )
        }
      }
    }
  },
  methods: {
    fileChanged (value) {
      console.log('fileChanged', value)
      if (this.max === 1) {
        this.data = [value]
      } else {
        this.data = value
      }
      this.$emit(
        'change',
        value
      )
    },
    getTokened () {
      let that = this
      getToken({}).then(res => {
        that.uploadData.token = res.token
        that.https = res.domain
      })
    },
    // 上传前回调
    beforeUploadVideo (file) {
      var fileSize = file.size / 1024 / 1024 < 20
      if (
        [
          'image/png',
          'image/jpeg',
          'image/jpg',
          'image/gif',
          'image/webp',
          'image/svg+xml',
          'image/tiff',
          'image/bmp',
          'image/x-icon'
        ].indexOf(file.type) == -1
      ) {
        this.$message.error('请上传正确的图片格式')
        return false
      }
      if (!fileSize) {
        this.$message.error('图片大小不能超过20M')
        return false
      }
      this.uploadData.key = `_img_${new Date().getTime()}_${file.name}`
      this.isShowUploadVideo = false
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    // 上传成功回调
    skuImg (res, file, flList) {
      let that = this
      that.isShowUploadVideo = true
      that.videoFlag = false
      that.videoUploadPercent = 0
      console.log('that.https + "/" + res.key', that.https + '/' + res.key)
      if (this.data == '') {
        this.data = []
      }
      if (flList.length > that.max) {
        that.$message.info(`最大上传${that.max}个音频`)
        return
      }
      that.data.push(that.https + '/' + res.key)

      if (this.max === 1) {
        this.$emit(
          'change',
          this.data[0]
        )
      } else {
        this.$emit(
          'change',
          this.data.map(item => {
            return item
          })
        )
      }
    },
    reMainVip (index) {
      console.log('max', this.max)
      if (this.max === 1) {
        this.$emit(
          'change',
          ''
        )
      } else {
        this.$emit(
          'change',
          this.filterManage
            .filter((_, i) => i !== index)
            .map(item => {
              return item || item
            })
        )
      }
    }
  },

  mounted () {
    console.log('typeof this.filterManage', typeof this.filterManage)
    console.log('this.data', this.data)
    if (this.max === 1) {
      this.data = [this.filterManage]
    } else {
      if (!this.data) {
        this.data = []
      }
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
.upload-avatar,
.zgu-upload {
  display: flex;
  flex-wrap: wrap;
}
.album {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;

}
.el-upload__tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  line-height: 16px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-item {
  position: relative;
  overflow: hidden;
  line-height: 100px;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  margin: 0 8px 8px 0;
  display: inline-block;
}

.upload-list__item-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s;

  &:hover {
    opacity: 1;
    cursor: pointer;
  }

  .upload-list__item-delete {
    margin-left: 15px;
  }
}
</style>
<style lang="scss">
.avatar-uploader {
  display: flex;
}

.el-upload {
  text-align: center;
  cursor: pointer;
  outline: 0;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #666;
}

.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
</style>
